module.exports = __webpack_public_path__ + "static/media/pngwing.com.6d4e363f.png";